var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRemember(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 621.34 288.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{font-size:77px;fill:#6efaff;font-family:Montserrat-SemiBold, Montserrat;font-weight:600;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remember_names",
    "data-name": "Remember names"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M550.74,145.44A29.51,29.51,0,0,1,521.23,175h-.65a29.36,29.36,0,0,1-14.73-4.32,37,37,0,0,0-14.07-23.5c0-.56,0-1.12,0-1.68a29.52,29.52,0,0,1,44.13-25.63c.37.21.73.43,1.08.65h0a29.54,29.54,0,0,1,13.77,23.78C550.73,144.64,550.74,145,550.74,145.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523.2,246.69v32.49c-48.4,20.5-103.06.95-103.06.95V246.69a35.31,35.31,0,0,1,11.2-25.62,38.91,38.91,0,0,1,23-10.46h0a36.84,36.84,0,0,0,12.46,3c.81.05,1.63.08,2.45.08s1.63,0,2.44-.08a37,37,0,0,0,12.93-3.24h.5C506.05,210.42,523.2,226.74,523.2,246.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M569.81,214.86v32.49A119.82,119.82,0,0,1,535,256v-1.78a54.23,54.23,0,0,0-10-31.38,56.34,56.34,0,0,0-6.68-7.89,60.27,60.27,0,0,0-21.38-13.6,36.92,36.92,0,0,0,9.4-22.75h25.4c1.22,0,2.44,0,3.63.16C554.6,180.51,569.81,196.08,569.81,214.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523.2,246.69v32.49c-48.4,20.5-103.06.95-103.06.95V246.69a35.31,35.31,0,0,1,11.2-25.62,38.91,38.91,0,0,1,23-10.46h0a36.84,36.84,0,0,0,12.46,3c.81.05,1.63.08,2.45.08s1.63,0,2.44-.08a37,37,0,0,0,12.93-3.24h.5C506.05,210.42,523.2,226.74,523.2,246.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417.84,175a29.53,29.53,0,0,1-28.54-23.21A37.9,37.9,0,0,1,417.84,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357,214.24v14.41a171.49,171.49,0,0,1-39.95-7.86V187.35a35.33,35.33,0,0,1,11.2-25.62,39,39,0,0,1,26.92-10.66H382l1.08,0a35.39,35.39,0,0,0,10.35,19.82,47.24,47.24,0,0,0-22.7,12A43.25,43.25,0,0,0,357,214.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M550.1,151.57a29.52,29.52,0,0,1-10.27,16.78c-1.25-.21-2.52-.37-3.8-.49-1.54-.15-3.09-.21-4.66-.21h-6.93a36.82,36.82,0,0,1,5-5.92A38.75,38.75,0,0,1,550.1,151.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M621.34,187.35v32.49A123.13,123.13,0,0,1,580.25,229V214.17c0-20.44-14-37.9-33.38-44.11A35.45,35.45,0,0,0,556,152.83c.12-.59.23-1.17.32-1.76h26.89C604.18,151.07,621.34,167.39,621.34,187.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.53,206.08l-1.32,0c-.45,0-.89,0-1.33,0a29.5,29.5,0,0,1-28.07-27,38,38,0,0,1,29.4,23A34.2,34.2,0,0,1,470.53,206.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.44,203.33a47.17,47.17,0,0,0-20.94,11.51,43.06,43.06,0,0,0-13.66,31.24v10.11a171.67,171.67,0,0,1-40.23-7.89V214.86a35.29,35.29,0,0,1,11.2-25.61,38.87,38.87,0,0,1,25.73-10.64c.39,0,.79,0,1.19,0h25.39A37,37,0,0,0,443.44,203.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.67,214.86v32.49c-1.17.5-2.36,1-3.54,1.42-16.22,6.21-33,8.12-48,7.94v-10a35.31,35.31,0,0,1,11.2-25.62,38.91,38.91,0,0,1,23-10.46h0a36.84,36.84,0,0,0,12.46,3c.81.05,1.63.08,2.45.08s1.63,0,2.44-.08C471.66,214.06,471.67,214.46,471.67,214.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.61,179.08a29.52,29.52,0,0,1-28.08,27l-1.32,0c-.45,0-.89,0-1.33,0a35.78,35.78,0,0,1,10.06-16.83A38.71,38.71,0,0,1,498.61,179.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523.2,246.69v10a178.41,178.41,0,0,1-55.07-7.92l-1.39-.47V214.86c0-.4,0-.8,0-1.2.81.05,1.63.08,2.45.08s1.63,0,2.44-.08a37,37,0,0,0,12.93-3.24h.5C506.05,210.42,523.2,226.74,523.2,246.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M569.81,214.86v32.49A119.82,119.82,0,0,1,535,256l-.48.05v-10A42.26,42.26,0,0,0,528,223.64a45.11,45.11,0,0,0-9.76-11.06,47.63,47.63,0,0,0-22.44-10.1c.36-.37.72-.75,1.06-1.14a36.92,36.92,0,0,0,9.4-22.75h25.4c1.22,0,2.44,0,3.63.16C554.6,180.51,569.81,196.08,569.81,214.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523.2,246.69v32.49c-48.4,20.5-103.06.95-103.06.95V246.69a35.31,35.31,0,0,1,11.2-25.62,38.91,38.91,0,0,1,23-10.46h0a36.84,36.84,0,0,0,12.46,3c.81.05,1.63.08,2.45.08s1.63,0,2.44-.08a37,37,0,0,0,12.93-3.24h.5C506.05,210.42,523.2,226.74,523.2,246.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.91,115.94v.49A29.48,29.48,0,0,1,385,92.72c0-.16,0-.33,0-.49A29.46,29.46,0,0,1,396.91,115.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.42,118.17A29.54,29.54,0,0,1,403.19,120a29.63,29.63,0,0,1,26.23-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.28,88.08a38.8,38.8,0,0,0,7.41,22.85,29.09,29.09,0,0,1-2.89,3.19,35.49,35.49,0,0,0-31.51-.91A36,36,0,0,0,386,85.11,29.51,29.51,0,0,1,434.3,70.86,38.68,38.68,0,0,0,430.28,88.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444,92.72a29.28,29.28,0,0,1-2.54,12A32.47,32.47,0,0,1,439,76.37,29.3,29.3,0,0,1,444,92.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.64,145.44c0,.31,0,.64,0,.95a37.1,37.1,0,0,0-15.16,24.85A29.42,29.42,0,0,1,418.13,175h-.29a29.46,29.46,0,0,1-29.21-29.51c0-.15,0-.3,0-.45a29.07,29.07,0,0,1,2.55-11.58v0a29.12,29.12,0,0,1,3.14-5.41h0a29.59,29.59,0,0,1,8.81-8h0a29.51,29.51,0,0,1,44.45,25.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M550.74,145.44A29.51,29.51,0,0,1,521.23,175h-.65a29.36,29.36,0,0,1-14.73-4.32,37,37,0,0,0-14.07-23.5c0-.56,0-1.12,0-1.68a29.52,29.52,0,0,1,44.13-25.63c.37.21.73.43,1.08.65h0a29.54,29.54,0,0,1,13.77,23.78C550.73,144.64,550.74,145,550.74,145.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.71,176.61c0,.83,0,1.65-.1,2.47a29.52,29.52,0,0,1-28.08,27l-1.32,0c-.45,0-.89,0-1.33,0a29.5,29.5,0,0,1-28.07-27c-.07-.82-.1-1.64-.1-2.47a29.51,29.51,0,0,1,29.5-29.52,29.52,29.52,0,0,1,29.35,26.52A29.83,29.83,0,0,1,498.71,176.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.91,87.91a39.46,39.46,0,0,0-78.5-.19,38.8,38.8,0,0,0-.22,4.19c0,1.12,0,2.22.14,3.31a39.45,39.45,0,0,0,37.54,36.11c.59,0,1.18,0,1.78,0s1.18,0,1.77,0A39.47,39.47,0,0,0,164,95.22c.09-1.09.14-2.19.14-3.31C164.11,90.56,164,89.22,163.91,87.91ZM138.68,123.4c-9.09,3.08-17.74,1.77-19.33-2.93s4.48-11,13.57-14.08,17.75-1.76,19.34,2.93S147.77,120.32,138.68,123.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.56,88.08a32.36,32.36,0,1,1-1.13-8.47A32,32,0,0,1,501.56,88.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M535.86,119.81c.37.21.73.43,1.08.65l-.92.33a29.71,29.71,0,0,1-9.15,1.44,29.31,29.31,0,0,1-15.71-4.53,29.63,29.63,0,0,1,24.7,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500.43,79.61a32,32,0,0,1,1.13,8.47,32.38,32.38,0,0,1-2.88,13.36,29.64,29.64,0,0,1,1.75-21.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M554.57,82.54a36.46,36.46,0,0,0-19,29.7,36.18,36.18,0,0,0-30.19.7,29.81,29.81,0,0,1-3.23-4.11A39,39,0,0,0,505,72.88a29.51,29.51,0,0,1,49.53,9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M542.5,116.19c0-.52,0-1,0-1.58a29.5,29.5,0,0,1,13.77-25c.1,1,.16,2,.16,3.08A29.49,29.49,0,0,1,543.61,117"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M542.5,116.19c0-.52,0-1,0-1.58A29.51,29.51,0,1,1,557,140a36.15,36.15,0,0,0-13.38-23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.2,133.39a29.12,29.12,0,0,1,3.14-5.41A28.58,28.58,0,0,1,391.2,133.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.91,115.94v.49c0,.2,0,.4,0,.6a35.43,35.43,0,0,0-14,24,29.52,29.52,0,1,1,14-25.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.64,123.8a30.11,30.11,0,0,1,6.79,20.31s17.66-9,31-.91c0,0,1.49-15.17,7-19.4C492.35,123.8,467.94,121.69,447.64,123.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.84,
    y: 139.15,
    width: 84.99,
    height: 138.08,
    rx: 6.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1.45,
    y: 159.85,
    width: 79.72,
    height: 21.95,
    rx: 10.97,
    transform: "translate(55.36 -3.44) rotate(18.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.52,
    y: 152.53,
    width: 57.91,
    height: 21.95,
    rx: 10.97,
    transform: "translate(-95.35 113.64) rotate(-48.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.49,
    y: 152.53,
    width: 57.91,
    height: 21.95,
    rx: 10.97,
    transform: "translate(181.21 -78.5) rotate(48.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 180.53,
    y: 159,
    width: 79.72,
    height: 21.95,
    rx: 10.97,
    transform: "translate(-44.45 84.41) rotate(-19.74)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(185.09 109.15) rotate(21.9)"
  }, "?"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(159.54 60.72) rotate(21.9)"
  }, "?"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(242.77 104.73) rotate(21.9)"
  }, "?")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemember);
export default __webpack_public_path__ + "static/media/ic_remember.defae17974acb547df87e0adf1a41875.svg";
export { ForwardRef as ReactComponent };